// extracted by mini-css-extract-plugin
export default {"Folders":"Folders_Folders__7DOD3","swing-in":"Folders_swing-in__9wnWM"};